// extracted by mini-css-extract-plugin
module.exports = {"emptyBlogs":"BlogsPage_emptyBlogs__C__m7","itemPost":"BlogsPage_itemPost__PMXzX"};